import { useCallback } from 'react';
/**
 * @example
 *  const filters = { foo: '', bar: 'abc-123' };
 *  const { hasFilter } = useHasFilter(filters);
 *  hasFilter('foo') && <Foo>
 * @param filters
 */
export function useHasFilter(filters) {
    const hasFilter = useCallback((key) => {
        if (filters == null) {
            return false;
        }
        return Boolean(filters[key]);
    }, [filters]);
    return {
        hasFilter,
    };
}
